import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { ReleaseNote } from "src/app/model/release-note";
import { AppState } from "src/app/store/app.reducer";
import { selectPrivacyNoteList } from "src/app/store/user/user.selector";
import { StandardPageLayout } from "../../stdlayoutlib/classes.stdlayoutlib";

@Component({
	templateUrl: './privacy-note.dialog.component.html',
})
export class PrivacyNoteDialogComponent implements OnInit, OnDestroy {

	privacyNoteList?: ReleaseNote[];
	privacyNoteList$: Observable<ReleaseNote[]>;
	privacyNoteListSub?: Subscription;

	// design
	screenWidth: number;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.privacyNoteList$ = this.store.select(selectPrivacyNoteList);
	}

	ngOnInit(): void {
		this.privacyNoteListSub = this.privacyNoteList$
			.subscribe(privacyNoteList => {
				this.privacyNoteList = privacyNoteList;
			}
			);
	}

	closeDialog(): void {
		/*if (this.privacyNoteList !== undefined && this.privacyNoteList.length > 0) {
			this.store.dispatch(UserActions.setFePrivacyVersion({ version: this.privacyNoteList[0].ReleaseVersion }));
		}*/
		this.ref.close();
	}

	ngOnDestroy(): void {
		this.privacyNoteListSub?.unsubscribe();
	}

	// Design
	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	dynamicButtonWidth(): string {
		return this.screenWidth <= this.MIN_TWO_BUTTONS_DIALOG_WIDTH
			? 'w-full'
			: 'w-16rem';
	}


	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}